import * as React from 'react';

import { ErrorListContext } from '../ErrorListContext';
import { ErrorDisplayInfo } from '../types/ErrorDisplayInfo';
import { ErrorList } from '../types/ErrorList';

export type ErrorReporterProps = ErrorDisplayInfo;

/**
 * Reports an error to a containing ErrorList React Context.
 * Note that the error will remain in the ErrorList while this component remains in the tree.
 */
export class ErrorReporter extends React.Component<ErrorReporterProps> {

  public render() {
    return (
      <ErrorListContext.Consumer>
        {errorList => (
          <ErrorReporterInternal
            errorCode={this.props.errorCode}
            errorMessage={this.props.errorMessage}
            errorList={errorList}
          />
        )}
      </ErrorListContext.Consumer>
    );
  }

}

type ErrorReporterInternalProps = ErrorReporterProps & {
  readonly errorList: ErrorList;
};

class ErrorReporterInternal extends React.Component<ErrorReporterInternalProps> {

  private errorId: string | null = null;

  public componentDidMount() {
    this.reportError();
  }

  public componentDidUpdate(prevProps: ErrorReporterInternalProps) {
    if (this.props.errorCode !== prevProps.errorCode ||
      this.props.errorMessage !== prevProps.errorMessage
    ) {
      this.reportError();
    }
  }

  public componentWillUnmount() {
    this.removeError();
  }

  public render() {
    return null;
  }

  private reportError() {
    this.removeError();
    this.errorId = this.props.errorList.addError(this.props);
  }

  private removeError() {
    if (this.errorId != null) {
      this.props.errorList.removeError(this.errorId);
      this.errorId = null;
    }
  }

}
